//默认导入
const { ccclass, property } = cc._decorator;
import ModuleBase, { ViewLayer, moduleInit } from "../../../../framework/core/mvvm/module_base";
import NetPromptView from "./netprompt_view";

@ccclass
@moduleInit("NetPrompt")
export default class NetPrompt extends ModuleBase<NetPromptView, null> {

    scheduleCallback: Function

    constructor() {
        super();
        this.package = "public";
        this.layer = ViewLayer.High;
        this.windowPrefabResPath = "package/public/public_netprompt";
        this.viewType = NetPromptView;
    }

    onShow(intentData) {
        // this.view.reconnectNode.active = false
        // this.view.mainNode.active = false
        if (this.scheduleCallback != null) {
            this.unschedule(this.scheduleCallback);
            this.scheduleCallback = null;
        }
        if (intentData && intentData.autoClose) {
            return
        }
        let self = this
        this.scheduleCallback = function () { self.hide() }
        this.unschedule(this.laterShow)
        if (intentData && intentData.showImmediately) {
            this.view.mainNode.active = true
        } 
        else if (intentData && intentData.hideAllTheTime){
            this.view.mainNode.active = false
        }  else {
            if (!this.view.mainNode.active) {
                this.view.mainNode.active = false
                this.scheduleOnce(this.laterShow, 0.3)
            }
        }
        this.scheduleOnce(this.scheduleCallback, intentData && intentData.showLongTime ? 40 : 12)
        // this.view.reconnectNode.active = intentData && intentData.reconnect
        this.view.startProgress()
    }

    private laterShow() {
        cc.log("lateShow")
        this.view.mainNode.active = true
    }

    onHide() {
        if (this.view && this.view.mainNode) {
            this.view.mainNode.active = false
        }
        super.onHide()
    }

    onDisable() {
        if (this.view && this.view.mainNode) {
            this.view.mainNode.active = false
        }
        this.unscheduleAllCallbacks()
    }

    onDestroy() {
        this.unscheduleAllCallbacks()
    }

    hideWithShowId(showId : number) {
        if (showId == this.showId) {
            this.hide()
        }
    }
}